import './assets/main.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'

import './styles/global.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import AppPageLoader from '@/components/shared/AppPageLoader.vue'
import router from './router'
import i18n from './i18n'

import { library } from '@fortawesome/fontawesome-svg-core'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faPowerOff,
  faUtensils,
  faHotel,
  faPlus,
  faPlusCircle,
  faChartPie,
  faMapMarkerAlt,
  faEye,
  faEyeSlash,
  faPen,
  faToggleOn,
  faToggleOff,
  faSearch,
  faStoreSlash,
  faTrash,
  faArrowLeft,
  faCheck,
  faTimes,
  faBuilding,
  faLocationArrow,
  faClock,
  faPhone,
  faEnvelope,
  faGlobe,
  faExclamationTriangle,
  faArrowRight,
  faImage,
  faBars,
  faGaugeHigh,
  faNewspaper,
  faCalendar,
  faCalendarDay,
  faSpinner,
  faExclamationCircle,
  faInfoCircle,
  faGripVertical,
  faCloudUploadAlt,
  faEllipsisV,
  faEdit,
  faLink,
  faUsersGear,
  faUser,
  faUserCircle,
  faUserGroup,
  faCalendarAlt,
  faUserCheck,
  faUserPlus,
  faUserClock,
  faUserSlash,
  faMagnifyingGlass,
  faIdBadge,
  faCheckCircle,
  faTimesCircle,
  faGift,
  faBoxOpen,
  faStar,
  faCrown,
  faLock,
  faUnlock,
  faQrcode,
  faPercent,
  faCoins,
  faBuilding as farBuilding,
  faUserShield,
  faAward,
  faReceipt,
  faTable,
  faLayerGroup,
  faHashtag,
  faUsers,
  faDownload,
  faPrint,
  faCheckDouble,
  faCheckSquare,
  faPencilAlt,
  faUserTie,
  faBan,
  faClipboardList,
  faCartShopping,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faChartBar,
  faWineGlassAlt,
  faStore,
  faRectangleList,
  faCashRegister,
  faSync,
  faPaperPlane,
  faBullhorn,
  faFilter,
  faTicket,
  faTag,
  faArrowUpRightFromSquare,
  faKey,
  faCreditCard,
  faFloppyDisk,
  faCopy,
  faTruck,
  faPlug,
  faCircleNotch
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faPowerOff,
  faUtensils,
  faHotel,
  faPlus,
  faPlusCircle,
  faChartPie,
  faMapMarkerAlt,
  faEye,
  faEyeSlash,
  faPen,
  faToggleOn,
  faToggleOff,
  faSearch,
  faStoreSlash,
  faTrash,
  faArrowLeft,
  faCheck,
  faTimes,
  faBuilding,
  faLocationArrow,
  faClock,
  faPhone,
  faEnvelope,
  faGlobe,
  faExclamationTriangle,
  faArrowRight,
  faImage,
  faBars,
  faGaugeHigh,
  faNewspaper,
  faCalendar,
  faCalendarDay,
  faSpinner,
  faExclamationCircle,
  faInfoCircle,
  faGripVertical,
  faCloudUploadAlt,
  faEllipsisV,
  faEdit,
  faLink,
  faUsersGear,
  faUser,
  faUserCircle,
  faUserGroup,
  faCalendarAlt,
  faUserCheck,
  faUserPlus,
  faUserClock,
  faUserSlash,
  faMagnifyingGlass,
  faIdBadge,
  faCheckCircle,
  faTimesCircle,
  faGift,
  faBoxOpen,
  faStar,
  faCrown,
  faLock,
  faUnlock,
  faQrcode,
  faPercent,
  faCoins,
  farBuilding,
  faUserShield,
  faAward,
  faReceipt,
  faTable,
  faLayerGroup,
  faHashtag,
  faUsers,
  faDownload,
  faPrint,
  faCheckDouble,
  faCheckSquare,
  faPencilAlt,
  faUserTie,
  faBan,
  faClipboardList,
  faCartShopping,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faChartBar,
  faWineGlassAlt,
  faStore,
  faRectangleList,
  faCashRegister,
  faSync,
  faPaperPlane,
  faBullhorn,
  faFilter,
  faTicket,
  faTag,
  faArrowUpRightFromSquare,
  faKey,
  faCreditCard,
  faFloppyDisk,
  faCopy,
  faTruck,
  faPlug,
  faCircleNotch
)

const app = createApp(App)

function checkTranslationsAvailability() {

  try {

    const windowObj = window as any;
    if (windowObj._i18nDebug && windowObj._i18nDebug.testTranslation) {

      setTimeout(() => {
        try {
          const test = windowObj._i18nDebug.testTranslation('establishments.title');
        } catch (err) {

        }
      }, 0);
    } else {

    }
  } catch (err) {

  }
}

app.use(createPinia())
app.use(router)
app.use(i18n)

app.component('font-awesome-icon', FontAwesomeIcon)
app.component('AppPageLoader', AppPageLoader)

app.mount('#app')

setTimeout(checkTranslationsAvailability, 1000)